import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import MaskUtil from "utils/MaskUtil";

import { Password } from "primereact/password";

import { useLanguage } from "context/LanguageContext";
import { useNotification } from "context/NotificationContext"; // Importa o Provider e o hook

const CadastroForm = ({setisLogin}) => {
  console.log(setisLogin);
  const { GetTranslation } = useLanguage();
  const navigate = useNavigate();
  const showNotification = useNotification(); // Hook para usar as notificações

  const [Data, setData] = useState({});
  const [passwordError, setPasswordError] = useState("");

  const validarCamposObrigatorios = () => {
    const camposObrigatorios = [
      { campo: "nome", label: GetTranslation("Name_of_Institution") },
      { campo: "CEP", label: GetTranslation("ZIP_Code") },
      {
        campo: "telefone",
        label: GetTranslation("Institution_Telephone_Number")
      },
      { campo: "responsavel", label: GetTranslation("Name_Responsible") },
      { campo: "email", label: GetTranslation("Email_Responsible") },
      { campo: "senha", label: GetTranslation("Password") },
      { campo: "confirme_senha", label: GetTranslation("Confirm_Password") }
    ];

    for (let campo of camposObrigatorios) {
      if (!Data[campo.campo]) {
        return campo.label; // Retorna o nome amigável do campo faltante
      }
    }
    return null;
  };

  // Função para verificar se a senha é forte
  const isStrongPassword = (password) => {
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return strongPasswordRegex.test(password);
  };

  const CadastroSe = (event) => {
    event.preventDefault();

    const campoFaltante = validarCamposObrigatorios();
    if (campoFaltante) {
      showNotification({
        type: "warning",
        message: `${campoFaltante} ${GetTranslation("is_required")}`
      });
      return;
    }

    if (!isStrongPassword(Data.senha)) {
      showNotification({
        type: "error",
        message: GetTranslation("password_strength_error") || 
                 "A senha deve ter no mínimo 8 caracteres, incluindo letras maiúsculas, minúsculas, números e caracteres especiais."
      });
      return;
    }

    if (Data.senha !== Data.confirme_senha) {
      showNotification({
        type: "error",
        message: GetTranslation("password_mismatch")
      });
      return;
    }

    console.log("Sending institution data:", Data);

    // Enviar dados da instituição usando fetch
    fetch(`${process.env.REACT_APP_API_URL}/institution/register_institution`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        nome_instituicao: Data.nome,
        rua: Data.rua,
        numero: Data.numero,
        complemento: Data.complemento,
        bairro: Data.bairro,
        cidade: Data.cidade,
        estado: Data.estado,
        CEP: Data.CEP,
        telefone: Data.telefone
      })
    })
      .then((response) => response.json())
      .then((institutionResponse) => {
        if (institutionResponse.success) {
          const institutionId = institutionResponse.institution_id;

          // Enviar dados do usuário usando fetch
          fetch(`${process.env.REACT_APP_API_URL}/user/register_user`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              responsavel: Data.responsavel,
              email: Data.email,
              senha: Data.senha,
              contato: Data.contato,
              institution_ids: Array.isArray(institutionId)
                ? institutionId
                : [institutionId]
            })
          })
            .then((response) => response.json())
            .then((userResponse) => {
              console.log("User response:", userResponse); // Adicionado para depuração
              if (userResponse.success) {
                showNotification({
                  type: "success",
                  message: GetTranslation("Register_Success")
                });
                localStorage.removeItem("token");
                setisLogin(true);
              } else {
                showNotification({
                  type: "error",
                  message:
                    userResponse.error || GetTranslation("Register_Error")
                });
              }
            })
            .catch((error) => {
              console.error("Error during user registration:", error);
              showNotification({
                type: "error",
                message: GetTranslation("Register_Error")
              });
            });
        } else {
          showNotification({
            type: "error",
            message:
              institutionResponse.error || GetTranslation("Register_Error")
          });
        }
      })
      .catch((error) => {
        console.error("Error during institution registration:", error);
        showNotification({
          type: "error",
          message: GetTranslation("Register_Error")
        });
      });
  };

  const HandleChange = (e) => {
    const { name, value } = e.target;
    setData((prevValues) => ({ ...prevValues, [name]: value }));

    if (name === "CEP" && value.length === 9) {
      BuscarEndereco(value);
    }
  };

  const IsNumeric = (text) => !isNaN(text);

  // Função para buscar endereço via API do ViaCEP
  const BuscarEndereco = (cep) => {
    let CEPWithoutDash = cep.replace("-", "");
    if (IsNumeric(CEPWithoutDash) && CEPWithoutDash.length === 8) {
      fetch(`https://viacep.com.br/ws/${CEPWithoutDash}/json/`)
        .then((res) => res.json())
        .then((response) => {
          if (response && !response.erro) {
            const { logradouro, bairro, localidade, uf, complemento } = response;
            setData((prevState) => ({
              ...prevState,
              rua: logradouro,
              bairro: bairro,
              cidade: localidade,
              estado: uf,
              complemento: complemento || prevState.complemento
            }));
          } else {
            setData((prevState) => ({
              ...prevState,
              rua: "",
              bairro: "",
              cidade: "",
              estado: "",
              complemento: "",
              endereco: "CEP não encontrado"
            }));
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar endereço:", error);
          setData((prevState) => ({
            ...prevState,
            rua: "",
            bairro: "",
            cidade: "",
            estado: "",
            complemento: "",
            endereco: "Erro ao buscar endereço"
          }));
        });
    }
  };

  return (
    <div className="box-cadastro">
      <h1>{GetTranslation("Institution_Registration")}</h1>
      <form className="form-cadastro" onSubmit={CadastroSe}>
        <h2>{GetTranslation("Institution")}</h2>
        <hr />
        <div className="item-input">
          <label htmlFor="nome-instituicao" className="form-label">
            {GetTranslation("Name_of_Institution")}
          </label>
          <InputText
            id="nome-instituicao"
            name="nome"
            className="w-50"
            value={Data.nome || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="CEP" className="form-label">
            {GetTranslation("ZIP_Code")}
          </label>
          <InputMask
            id="CEP"
            mask="99999-999"
            className="w-50"
            value={Data.CEP || ""}
            onChange={(e) =>
              HandleChange({ target: { name: "CEP", value: e.value } })
            }
          />
        </div>
        <div className="item-input">
          <label htmlFor="rua" className="form-label">
            {GetTranslation("Street")}
          </label>
          <InputText
            id="rua"
            name="rua"
            className="w-50"
            value={Data.rua || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="numero" className="form-label">
            {GetTranslation("Number")}
          </label>
          <InputText
            id="numero"
            name="numero"
            className="w-50"
            value={Data.numero || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="complemento" className="form-label">
            {GetTranslation("Complement")}
          </label>
          <InputText
            id="complemento"
            name="complemento"
            className="w-50"
            value={Data.complemento || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="bairro" className="form-label">
            {GetTranslation("Neighborhood")}
          </label>
          <InputText
            id="bairro"
            name="bairro"
            className="w-50"
            value={Data.bairro || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="cidade" className="form-label">
            {GetTranslation("City")}
          </label>
          <InputText
            id="cidade"
            name="cidade"
            className="w-50"
            value={Data.cidade || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="estado" className="form-label">
            {GetTranslation("State")}
          </label>
          <InputText
            id="estado"
            name="estado"
            className="w-50"
            value={Data.estado || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="telefone" className="form-label">
            {GetTranslation("Institution_Telephone_Number")}
          </label>
          <InputText
            id="telefone"
            name="telefone"
            className="w-50"
            value={Data.telefone || ""}
            onChange={HandleChange}
          />
        </div>
        <h2>{GetTranslation("Responsible")}</h2>
        <hr />
        <div className="item-input">
          <label htmlFor="responsavel" className="form-label">
            {GetTranslation("Name_Responsible")}
          </label>
          <InputText
            id="responsavel"
            name="responsavel"
            className="w-50"
            value={Data.responsavel || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="email" className="form-label">
            {GetTranslation("Email_Responsible")}
          </label>
          <InputText
            id="email"
            name="email"
            className="w-50"
            value={Data.email || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input">
          <label htmlFor="contato" className="form-label">
            {GetTranslation("Telefone_Ramal_Responsible")}
          </label>
          <InputText
            id="contato"
            name="contato"
            className="w-50"
            value={Data.contato || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="item-input senha">
          <div>
            <label htmlFor="senha" className="form-label">
              {GetTranslation("Password")}
            </label>
            <Password
              id="senha"
              name="senha"
              toggleMask
              className="w-50"
              value={Data.senha || ""}
              onChange={HandleChange}
            />
          </div>
          <p className="mt-1 mb-0" style={{fontSize:"10px"}}>{GetTranslation("Password_info")}</p>
        </div>
        <div className="item-input">
          <label htmlFor="confirme_senha" className="form-label">
            {GetTranslation("Confirm_Password")}
          </label>
          <Password
            id="confirme_senha"
            name="confirme_senha"
            toggleMask
            className="w-50"
            value={Data.confirme_senha || ""}
            onChange={HandleChange}
          />
        </div>
        <div className="d-flex justify-content-center mt-3">
          <button type="submit" className="btn btn-primary">
            {GetTranslation("Register")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroForm;
